import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { fontFamily } from '../../helpers/fontFamily';

const Pagination = ({ currentPage, setCurrentPage, pagy }) => {
  console.log("PAGY", pagy);
  if (!pagy || pagy.last <= 1) return null;

  const totalPages = pagy.last || 1;
  const maxPagesToShow = 5;

  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }


  return (
    <View style={{
      flexDirection: 'row',
      justifyContent: 'center',
      marginVertical: 20,
      flexWrap: 'wrap',
      gap: 10,
    }}>
      {pagy.prev && (
        <TouchableOpacity
          onPress={() => setCurrentPage(pagy.prev)}
          style={{
            padding: 10,
            borderRadius: 6,
            backgroundColor: 'transparent',
            border: "1px solid white",
          }}
        >
          <Text style={{ color: '#fff' }}>Prev</Text>
        </TouchableOpacity>
      )}
      {pageNumbers.map(page => (
        <TouchableOpacity
          key={page}
          onPress={() => setCurrentPage(page)}
          style={{
            padding: 10,
            borderRadius: 6,
            backgroundColor: 'transparent',
            border: currentPage === page ? '2px solid rgba(0, 0, 0, 0.3)' : '',
            textDecoration: currentPage === page ? 'underline' : 'none',
            textDecorationColor: currentPage === page ? 'white' : '',
            fontWeight: currentPage === page ? '600' : '300',
            fontSize: '16px',
          }}
        >
          <Text style={{ color: '#fff' }}>{page}</Text>
        </TouchableOpacity>
      ))}
      {pagy.next && (
        <TouchableOpacity
          onPress={() => setCurrentPage(pagy.next)}
          style={{
            padding: 10,
            borderRadius: 6,
            backgroundColor: 'transparent',
            border: "1px solid white",
          }}
        >
          <Text style={{ color: '#fff' }}>Next</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default Pagination;
